/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomerDto } from './CustomerDto';
import {
    CustomerDtoFromJSON,
    CustomerDtoFromJSONTyped,
    CustomerDtoToJSON,
    CustomerDtoToJSONTyped,
} from './CustomerDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface CustomerListResponse
 */
export interface CustomerListResponse {
    /**
     * 
     * @type {string}
     * @memberof CustomerListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof CustomerListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof CustomerListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof CustomerListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {Array<CustomerDto>}
     * @memberof CustomerListResponse
     */
    data?: Array<CustomerDto>;
    /**
     * 
     * @type {number}
     * @memberof CustomerListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerListResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the CustomerListResponse interface.
 */
export function instanceOfCustomerListResponse(value: object): value is CustomerListResponse {
    return true;
}

export function CustomerListResponseFromJSON(json: any): CustomerListResponse {
    return CustomerListResponseFromJSONTyped(json, false);
}

export function CustomerListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CustomerDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function CustomerListResponseToJSON(json: any): CustomerListResponse {
    return CustomerListResponseToJSONTyped(json, false);
}

export function CustomerListResponseToJSONTyped(value?: CustomerListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CustomerDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

